module.exports = __webpack_public_path__ + "img/风光互补路灯.2e0746a4.png";